import React, { Component, PropTypes } from 'react';
import './ModalClose.css';

class ModalClose extends Component {

  render() {
    return (
			<svg className="modalClose__wrap" xmlns="http://www.w3.org/2000/svg" onClick={this.props.onClick} viewBox="2465.07 6570 25.93 25.93">
				<g id="Group_240" transform="translate(2465.07 6570)">
					<path id="Path_277" className="modalClose" d="M12.965,25.93A12.965,12.965,0,1,1,25.93,12.965,12.98,12.98,0,0,1,12.965,25.93Zm0-24.814A11.849,11.849,0,1,0,24.814,12.965,11.865,11.865,0,0,0,12.965,1.116Z"/>
					<path id="Path_278" className="modalClose" d="M125.557,126.209a.536.536,0,0,1-.394-.164l-9.676-9.669a.557.557,0,1,1,.788-.788l9.669,9.669a.558.558,0,0,1-.387.952Z" transform="translate(-107.755 -107.848)"/>
					<path id="Path_279" className="modalClose" d="M115.881,126.209a.536.536,0,0,1-.394-.164.559.559,0,0,1,0-.788l9.669-9.669a.557.557,0,0,1,.788.788l-9.663,9.669A.59.59,0,0,1,115.881,126.209Z" transform="translate(-107.755 -107.848)"/>
				</g>
			</svg>
    );
  }
}

ModalClose.propTypes = {
	onClick: PropTypes.func.isRequired
};

export default ModalClose;



/** WEBPACK FOOTER **
 ** ./src/icons/ModalClose/index.js
 **/